// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_review_review_module_ts":"e96ffe9522237574","src_app_time-card_time-card_module_ts":"4e87560525ce4d51"}[chunkId] + ".js";
};